import FlagAE from "./flag_ae.svg";
import FlagCN from "./flag_cn.svg";
import FlagGB from "./flag_gb.svg";
import GoogleSignInIcon from "./google.svg";
import IconAddToCart from "./ico_add_to_cart.svg";
import IconBreadCrumb from "./ico_breadcrumb.svg";
import IconCall from "./ico_call.svg";
import IconDownloadInvoice from "./ico_download_invoice.svg";
import IconEmail from "./ico_email.svg";
import IcoGrade from "./ico_grade.svg";
import IconLanguage from "./ico_language_selector.svg";
import IconMagnifier from "./ico_magnifier.svg";
import IconNoProductFound from "./ico_no_product_found.svg";
import IconNotice from "./ico_notice.svg";
import IconPdpAmex from "./ico_pdp_amex.svg";
import IconPdpApplePay from "./ico_pdp_applePay.svg";
import IconPdpMada from "./ico_pdp_mada.svg";
import IconPdpMastercard from "./ico_pdp_mastercard.svg";
import IconPdpVisa from "./ico_pdp_visa.svg";
import IconPolygon from "./ico_polygon.svg";
import IconSearchNotFound from "./ico_search_not_found.svg";
import IconSelectField from "./ico_select_field.svg";
import IconSelectedAccountMenu from "./ico_selected_account_menu.svg";
import IconSortByMobile from "./ico_sortby_mobile.svg";
import IconEyeOpen from "./icon-eye-alt.svg";
import IconEyeClose from "./icon-eye-slash.svg";
import IconMenuLinkArrow from "./icon-menu-link-arrow.svg";
import IconMiniBag from "./icon-mini-bag.svg";
import IconAccordionButton from "./icon_accordion_button.svg";
import IconAccountAddress from "./icon_account_address.svg";
import IconAccountContact from "./icon_account_contact.svg";
import IconAccountDashboard from "./icon_account_dashboard.svg";
import IconAccountFaq from "./icon_account_faq.svg";
import IconAccountLogout from "./icon_account_logout.svg";
import IconAccountOrder from "./icon_account_order.svg";
import IconAccountPrivacyPolicy from "./icon_account_privacy-policy.svg";
import IconAccountProfile from "./icon_account_profile.svg";
import IconAccountReturnRefund from "./icon_account_return_refund.svg";
import IconAccountTerms from "./icon_account_terms.svg";
import IconAccountWishlist from "./icon_account_wishlist.svg";
import IconArabic from "./icon_arabic.svg";
import IconAvatar from "./icon_avatar.svg";
import IconDisabledBackwardArrow from "./icon_backward_arrow.svg";
import IconBag from "./icon_bag.svg";
import IconBagWhite from "./icon_bag_white.svg";
import IconButtonProceedToCheckout from "./icon_btn_proceed_to_checkout.svg";
import IconCancelOrder from "./icon_cancel_order.svg";
import IconCartFailed from "./icon_cart_failed.svg";
import IconCartFailedMobile from "./icon_cart_failed_mobile.svg";
import IconCartSuccess from "./icon_cart_success.svg";
import IconCartSuccessMobile from "./icon_cart_success_mobile.svg";
import IconCheckBlack from "./icon_check_circle_black.svg";
import IconCheckGolden from "./icon_check_circle_gold.svg";
import IconCheckGreenSmall from "./icon_check_small.svg";
import IconCompanyInfo from "./icon_company_info.svg";
import IconContactFacebook from "./icon_contact_facebook.svg";
import IconContactHelp from "./icon_contact_help.svg";
import IconContactInstagram from "./icon_contact_instagram.svg";
import IconContactPhone from "./icon_contact_phone.svg";
import IconContactPhoneHomepage from "./icon_contact_phone_home.svg";
import IconContactSnapchat from "./icon_contact_snapchat.svg";
import IconContactTiktok from "./icon_contact_tiktok.svg";
import IconContactWhatsapp from "./icon_contact_whatsapp.svg";
import IconContactX from "./icon_contact_x.svg";
import IconCouponTag from "./icon_coupon_tag.svg";
import IconCross from "./icon_cross.svg";
import IconCrossSmallGold from "./icon_cross_small_gold.svg";
import IconCrossSmallRed from "./icon_cross_small_red.svg";
import IconCurrency from "./icon_currency_symbol.svg";
import IconCurrencyChinese from "./icon_currency_symbol_cn.svg";
import IconDeleteAccount from "./icon_delete_account.svg";
import IconDeleteAccountPage from "./icon_delete_account_page.svg";
import IconEmptyCart from "./icon_empty_cart.svg";
import IconEnglish from "./icon_english.svg";
import IconFilterBy from "./icon_filter_by.svg";
import IconForwardArrow from "./icon_forward_arrow.svg";
import IconForwardArrowBlack from "./icon_forward_arrow_black.svg";
import IconForwardArrowWhite from "./icon_forward_arrow_white.svg";
import IconGlobe from "./icon_globe.svg";
import IconGridChangeThreeCol from "./icon_grid_change_3_col.svg";
import IconGridChangeThreeColActive from "./icon_grid_change_3_col_active.svg";
import IconGridChangeFourCol from "./icon_grid_change_4_col.svg";
import IconGridChangeFourColActive from "./icon_grid_change_4_col_active.svg";
import IconLinkArrow from "./icon_link_arrow.svg";
import IconLocationPin from "./icon_location_pin.svg";
import IconLocationPinDiva from "./icon_location_pin_diva.svg";
import IconLogin from "./icon_login.svg";
import IconLoginWithOTP from "./icon_login_with_otp.svg";
import IconMail from "./icon_mail_solid.svg";
import IconNoAddress from "./icon_no_address.svg";
import IconNoAvatar from "./icon_no_avatar.svg";
import IconNoAvatarWhite from "./icon_no_avatar_white.svg";
import IconNoOrders from "./icon_no_orders.svg";
import IconNoRatingStar from "./icon_no_rating_star.svg";
import IconNoWishlist from "./icon_no_wishlist.svg";
import IconNotFound from "./icon_not_found.svg";
import IconPaginationArrow from "./icon_pagination_arrow.svg";
import IconPasswordUpdated from "./icon_password_updated.svg";
import IconPaymentAmex from "./icon_payment_amex.svg";
import IconPaymentMada from "./icon_payment_mada.svg";
import IconPaymentMastercard from "./icon_payment_mastercard.svg";
import IconPaymentPayfort from "./icon_payment_payfort.svg";
import IconPaymentTabby from "./icon_payment_tabby.svg";
import IconPaymentTamara from "./icon_payment_tamara.svg";
import IconPaymentTamaraLarge from "./icon_payment_tamara_large.svg";
import IconPaymentTamaraLargeArabic from "./icon_payment_tamara_large_ar.svg";
import IconPaymentVisa from "./icon_payment_visa.svg";
import IconPhoneSolid from "./icon_phone_solid.svg";
import IconPopularSearch from "./icon_popular_search.svg";
import IconRadioActive from "./icon_radio_active.svg";
import IconRatingStar from "./icon_rating_star.svg";
import IconRegister from "./icon_register.svg";
import IconSearchEmpty from "./icon_search_empty.svg";
import IconSearchItem from "./icon_search_item.svg";
import IconShare from "./icon_share.svg";
import IconSmallForwardArrow from "./icon_small_forward_arrow.svg";
import IconStepperActive from "./icon_stepper_active.svg";
import IconStepperInactive from "./icon_stepper_inactive.svg";
import IconTalkToUs from "./icon_talk_to_us.svg";
import IconWishlist from "./icon_wishlist_heart.svg";
import IconWishlistFilled from "./icon_wishlist_heart_filled.svg";
import IconWishlistWhite from "./icon_wishlist_heart_white.svg";
import IconWriteReview from "./icon_write_review.svg";
import IconWriteToUs from "./icon_write_to_us.svg";
import IconAboutUs from "./logo_about_us.svg";

export {
  FlagAE,
  FlagCN,
  FlagGB,
  GoogleSignInIcon,
  IcoGrade,
  IconAboutUs,
  IconAccordionButton,
  IconAccountAddress,
  IconAccountContact,
  IconAccountDashboard,
  IconAccountFaq,
  IconAccountLogout,
  IconAccountOrder,
  IconAccountPrivacyPolicy,
  IconAccountProfile,
  IconAccountReturnRefund,
  IconAccountTerms,
  IconAccountWishlist,
  IconAddToCart,
  IconArabic,
  IconAvatar,
  IconBag,
  IconBagWhite,
  IconBreadCrumb,
  IconButtonProceedToCheckout,
  IconCall,
  IconCancelOrder,
  IconCartFailed,
  IconCartFailedMobile,
  IconCartSuccess,
  IconCartSuccessMobile,
  IconCheckBlack,
  IconCheckGolden,
  IconCheckGreenSmall,
  IconCompanyInfo,
  IconContactFacebook,
  IconContactHelp,
  IconContactInstagram,
  IconContactPhone,
  IconContactPhoneHomepage,
  IconContactSnapchat,
  IconContactTiktok,
  IconContactWhatsapp,
  IconContactX,
  IconCouponTag,
  IconCross,
  IconCrossSmallGold,
  IconCrossSmallRed,
  IconCurrency,
  IconCurrencyChinese,
  IconDeleteAccount,
  IconDeleteAccountPage,
  IconDisabledBackwardArrow,
  IconDownloadInvoice,
  IconEmail,
  IconEmptyCart,
  IconEnglish,
  IconEyeClose,
  IconEyeOpen,
  IconFilterBy,
  IconForwardArrow,
  IconForwardArrowBlack,
  IconForwardArrowWhite,
  IconGlobe,
  IconGridChangeFourCol,
  IconGridChangeFourColActive,
  IconGridChangeThreeCol,
  IconGridChangeThreeColActive,
  IconLanguage,
  IconLinkArrow,
  IconLocationPin,
  IconLocationPinDiva,
  IconLogin,
  IconLoginWithOTP,
  IconMagnifier,
  IconMail,
  IconMenuLinkArrow,
  IconMiniBag,
  IconNoAddress,
  IconNoAvatar,
  IconNoAvatarWhite,
  IconNoOrders,
  IconNoProductFound,
  IconNoRatingStar,
  IconNotFound,
  IconNotice,
  IconNoWishlist,
  IconPaginationArrow,
  IconPasswordUpdated,
  IconPaymentAmex,
  IconPaymentMada,
  IconPaymentMastercard,
  IconPaymentPayfort,
  IconPaymentTabby,
  IconPaymentTamara,
  IconPaymentTamaraLarge,
  IconPaymentTamaraLargeArabic,
  IconPaymentVisa,
  IconPdpAmex,
  IconPdpApplePay,
  IconPdpMada,
  IconPdpMastercard,
  IconPdpVisa,
  IconPhoneSolid,
  IconPolygon,
  IconPopularSearch,
  IconRadioActive,
  IconRatingStar,
  IconRegister,
  IconSearchEmpty,
  IconSearchItem,
  IconSearchNotFound,
  IconSelectedAccountMenu,
  IconSelectField,
  IconShare,
  IconSmallForwardArrow,
  IconSortByMobile,
  IconStepperActive,
  IconStepperInactive,
  IconTalkToUs,
  IconWishlist,
  IconWishlistFilled,
  IconWishlistWhite,
  IconWriteReview,
  IconWriteToUs,
};
